import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@resideo/blueprint-react';
import styled from 'styled-components';
import { resideoProLink } from 'config/externalLinks';

import { ReactComponent as ResideoProLogo } from './resideo-pro-logo.svg';
import { ReactComponent as ResideoKnockoutLogo } from './resideo-knockout-logo.svg';

const StyledResideoKnockoutLogo = styled(ResideoKnockoutLogo)`
  fill: ${({ theme }) => theme.colors.header.icons};
  margin-right: ${({ theme }) => theme.space.medium};
`;

const LogoContainer = styled(Link)`
  align-items: center;
  display: flex;
`;

const StyledResideoProLogo = styled(ResideoProLogo)`
  fill: ${({ theme }) => theme.colors.header.icons};
`;

export const HeaderLogo: FC = props => {
  const { t } = useTranslation();

  return (
    <LogoContainer
      aria-label={t('header.primary.home')}
      href={resideoProLink}
      {...props}>
      <StyledResideoKnockoutLogo />
      <StyledResideoProLogo />
    </LogoContainer>
  );
};

export default HeaderLogo;
